import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { observable, action, reaction, toJS } from 'mobx';
import { FormattedMessage } from 'ui/i18n';
import { authorize } from 'utils/auth';
import { getIndexForItem } from 'state/helpers';

import { Loader, ChooseColorItem } from 'ui/components';

import './ChooseColor.scss';

@inject('ItemsState', 'CartState', 'CartItemsState')
@observer
export default class ChooseColor extends Component {
	static propTypes = {
		ItemsState: PropTypes.object.isRequired,
		CartState: PropTypes.object.isRequired,
		CartItemsState: PropTypes.object.isRequired,
		show: PropTypes.bool.isRequired,
		onRequestClose: PropTypes.func.isRequired,
		item: PropTypes.object.isRequired,
		handleAddToCart: PropTypes.func,
		inEditMode: PropTypes.bool,
	};

	static defaultProps = {
		handleAddToCart: () => true,
		inEditMode: false,
	};

	@action
	componentWillMount() {
		this.ItemsState.fetchChooseColors(
			this.item.category_id,
			this.item.id,
			this.item.pack_id,
			this.item.is_pack
		);

		reaction(
			() => this.ItemsState.fetchChooseColors.state.result,
			result => result && this.initColorGroupsQuantities(result)
		);

		this.addToCurrentCart();
		this.initPrevConfiguration();
		this.props.CartItemsState.itemCancelled = false;

		if (this.props.inEditMode) {
			this.props.CartItemsState.addUpdate(this.item, null, 'configurations');
		}
	}

	@observable isQuantityValid = false;
	prevConfigurations = null;
	colorGroupsQuantities = {};
	ItemsState = this.props.ItemsState;
	item = toJS(this.props.item);
	totalQuantity = {};

	initColorGroupsQuantities(items) {
		for (const key in items) {
			this.colorGroupsQuantities[items[key][0].id] = 0;
		}
	}

	initPrevConfiguration() {
		this.prevConfigurations = this.item.configurations;
	}

	addToCurrentCart() {
		if (!this.item.is_pack && !this.props.item.quantity_ordered) {
			this.props.CartItemsState.addToCurrentCart({
				...this.item,
				quantity_ordered: 0,
			});
		}
	}

	@action
	validateQuantity() {
		for (const key in this.colorGroupsQuantities) {
			if (this.colorGroupsQuantities[key] !== this.totalQuantity[key]) {
				this.isQuantityValid = false;
				return;
			}
		}
		this.isQuantityValid = true;
	}

	saveInCart() {
		const itemIndex = getIndexForItem(
			this.props.CartState.cartItems,
			this.item,
			this.item.is_pack
		);
		const updatedItemIndex = getIndexForItem(
			this.props.CartItemsState.cartUpdates,
			this.item,
			this.item.is_pack
		);

		if (itemIndex >= 0 && updatedItemIndex >= 0) {
			const initialConfigIndex = getIndexForItem(
				this.props.CartState.cart.items,
				this.item,
				this.item.is_pack
			);
			const updatedItem = this.props.CartItemsState.cartUpdates[
				updatedItemIndex
			];

			const initialItem = this.props.CartState.cart.items[initialConfigIndex];
			if (
				JSON.stringify(initialItem.configurations) ===
				JSON.stringify(updatedItem.configurations)
			) {
				this.props.CartItemsState.deleteUpdate(this.item, 'configurations');
				this.props.CartItemsState.deleteUpdate(this.item, 'quantity_ordered');
				updatedItem.quantity_ordered = initialItem.quantity_in_cart;
				updatedItem.quantity_in_cart = initialItem.quantity_in_cart;
			} else {
				updatedItem.quantity_in_cart = this.props.CartState.cartItems[
					itemIndex
				].quantity_ordered;
			}
			this.props.CartState.cartItems[itemIndex] = updatedItem;
		}
	}

	@action
	onClick() {
		if (this.props.inEditMode) {
			this.props.onRequestClose();
			//update UI
			this.saveInCart();
		} else {
			this.props.handleAddToCart();
			this.props.CartItemsState.itemCancelled = false;
		}
	}

	@action
	onCancel() {
		if (this.props.inEditMode) {
			const itemIndex = getIndexForItem(
				this.props.CartState.cartItems,
				this.item,
				this.item.is_pack
			);

			this.props.CartItemsState.deleteUpdate(
				this.item,
				'configurations',
				this.props.CartState.cartItems
			);
			this.props.CartItemsState.deleteUpdate(
				this.item,
				'quantity_ordered',
				this.props.CartState.cartItems
			);
			if (itemIndex >= 0) {
				const itemFromCart = this.props.CartState.cartItems[itemIndex];
				itemFromCart.quantity_ordered = itemFromCart.quantity_in_cart;
				itemFromCart.configurations = this.prevConfigurations;
				this.item.errorMsgId = null;
			}
		} else {
			this.props.CartItemsState.deleteFromCart({
				is_pack: this.item.is_pack,
				pack_id: this.item.pack_id,
				id: this.item.id,
			});
		}

		this.props.CartItemsState.itemCancelled = true;

		this.props.onRequestClose();
	}

	@action
	onChangeQty(itemId, totalSelectedQuantity) {
		this.colorGroupsQuantities[itemId] = totalSelectedQuantity;
		if (this.item.quantity_ordered) {
			this.validateQuantity();
		} else {
			this.isQuantityValid = totalSelectedQuantity <= this.item.quantity;
		}
	}

	@action
	getQtyOrdered(quantity, itemId) {
		if (this.props.item.quantity_ordered) {
			return (this.totalQuantity[itemId] = this.props.item.is_pack
				? this.props.item.quantity_ordered * quantity
				: this.props.item.quantity_ordered);
		}
		return 0;
	}

	render() {
		const { fetchChooseColors } = this.props.ItemsState;
		const { show } = this.props;
		const {
			quantity_ordered,
			is_pack,
			is_preview,
			number,
			base_number,
			name,
			quantity,
		} = this.item;
		const total = !quantity_ordered && !is_pack ? quantity : quantity_ordered;

		return (
			<Modal
				className="ReactModal__Content ChooseColor"
				overlayClassName="ReactModal__Overlay"
				isOpen={show}
				onRequestClose={this.onCancel.bind(this)}
				contentLabel="Choose Color"
			>
				<div className="ChooseColor-header">
					<FormattedMessage id="chooseColor.modalTitle" />
				</div>
				<h5 id="ChooseColorTitle">
					{is_pack ? name : `${base_number} - ${name}`}
				</h5>

				<div className="ChooseColor-content">
					{fetchChooseColors.handle({
						loading: () => <Loader />,
						rejected: () =>
							<div className="Error__not-available">
								<h3>
									<FormattedMessage
										id="colorItems.NotAvailable"
										values={{ itemNumber: this.itemNumber }}
									/>
								</h3>
							</div>,
						resolved: items =>
							<div>
								{Object.values(items).map((group, index) =>
									<ChooseColorItem
										key={index}
										items={group}
										totalQuantity={this.getQtyOrdered(
											group[0].quantity_in_pack,
											group[0].id
										)}
										quantity={quantity}
										cartItem={this.item}
										itemNumber={number}
										baseItemNumber={group[0].base_number}
										isPack={is_pack}
										isPreview={is_preview}
										onChange={this.onChangeQty.bind(this)}
										inEditMode={this.props.inEditMode}
									/>
								)}
							</div>,
					})}
				</div>
				<div className="row rightSide">
					<button
						className="btn btn-default pull-right choose-color-cancel"
						onClick={this.onCancel.bind(this)}
					>
						<FormattedMessage id="general.cancelText" />
					</button>
					<button
						className="btn btn-primary pull-right"
						onClick={this.onClick.bind(this)}
						disabled={
							!total ||
							!this.isQuantityValid ||
							!authorize(['AddToCart'], true, false)
						}
					>
						{this.props.inEditMode
							? 'OK'
							: <FormattedMessage id="general.addToCart" />}
					</button>
				</div>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ChooseColor/index.js